var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSimmOutlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 516.77 82.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 7px;\n      }\n\n      .cls-3 {\n        fill: #1d4d88;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 105.74,
    y1: 41.34,
    x2: 0,
    y2: 41.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1c4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1a3c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#172f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172b53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 57.81,
    y1: 39.88,
    x2: 105.67,
    y2: 39.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.35,
    y1: 39.12,
    x2: 56.69,
    y2: 39.12,
    gradientTransform: "translate(-.46 .07) rotate(-.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#182f59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#193a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4d88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 9.77,
    y1: 48.1,
    x2: 64.2,
    y2: 48.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 54.86,
    y1: 45.46,
    x2: 96.95,
    y2: 45.46,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Powersimm"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.56,78.91l-70.13.27c-9.9,0-17.93-7.65-17.93-17.09V20.59C3.5,11.15,11.53,3.5,21.43,3.5h62.88c9.9,0,17.93,7.65,17.93,17.09v37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.81 10.31 99.26 69.46 105.67 58.2 57.81 10.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m51.51,8.74c-.79.95-42.52,60.82-42.52,60.82L56.26,19.15l-4.75-10.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "9.77 72.01 58.86 24.2 64.2 35.19 9.77 72.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.86 8.26 91.56 82.66 96.95 73.92 54.86 8.26"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m122.71,20.4c3.02-.5,6.98-.94,12.03-.94,6.19,0,10.73,1.44,13.61,4.03,2.67,2.3,4.25,5.83,4.25,10.15s-1.3,7.85-3.74,10.37c-3.31,3.53-8.71,5.33-14.83,5.33-1.87,0-3.6-.07-5.04-.43v19.44h-6.26V20.4Zm6.26,23.4c1.37.36,3.1.5,5.18.5,7.56,0,12.17-3.67,12.17-10.37s-4.54-9.5-11.45-9.5c-2.74,0-4.82.22-5.9.5v18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m190.54,50.64c0,12.89-8.93,18.51-17.35,18.51-9.43,0-16.71-6.91-16.71-17.93,0-11.67,7.63-18.51,17.28-18.51s16.78,7.27,16.78,17.93Zm-27.65.36c0,7.63,4.39,13.39,10.58,13.39s10.58-5.69,10.58-13.54c0-5.9-2.95-13.39-10.44-13.39s-10.73,6.91-10.73,13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m200.54,33.51l4.61,17.71c1.01,3.89,1.94,7.49,2.59,11.09h.22c.79-3.53,1.94-7.27,3.1-11.02l5.69-17.79h5.33l5.4,17.43c1.3,4.18,2.3,7.85,3.1,11.38h.22c.58-3.53,1.51-7.2,2.67-11.3l4.97-17.5h6.26l-11.23,34.85h-5.76l-5.33-16.63c-1.22-3.89-2.23-7.34-3.1-11.45h-.14c-.86,4.18-1.94,7.78-3.17,11.52l-5.62,16.56h-5.76l-10.51-34.85h6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m253.82,52.09c.14,8.57,5.62,12.1,11.95,12.1,4.54,0,7.27-.79,9.65-1.8l1.08,4.54c-2.23,1.01-6.05,2.16-11.59,2.16-10.73,0-17.14-7.06-17.14-17.57s6.19-18.79,16.35-18.79c11.38,0,14.4,10.01,14.4,16.42,0,1.3-.14,2.3-.22,2.95h-24.48Zm18.58-4.54c.07-4.03-1.66-10.3-8.78-10.3-6.41,0-9.22,5.9-9.72,10.3h18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m286.37,44.38c0-4.1-.07-7.63-.29-10.87h5.54l.22,6.84h.29c1.58-4.68,5.4-7.63,9.65-7.63.72,0,1.22.07,1.8.22v5.98c-.65-.14-1.3-.22-2.16-.22-4.46,0-7.63,3.38-8.5,8.14-.14.86-.29,1.87-.29,2.95v18.58h-6.26v-23.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m309.26,60.73c2.81,1.73,6.91,3.17,11.23,3.17,6.41,0,10.15-3.38,10.15-8.28,0-4.54-2.59-7.13-9.14-9.65-7.92-2.81-12.82-6.91-12.82-13.75,0-7.56,6.26-13.18,15.7-13.18,4.97,0,8.57,1.15,10.73,2.38l-1.73,5.11c-1.58-.86-4.82-2.3-9.22-2.3-6.62,0-9.14,3.96-9.14,7.27,0,4.54,2.95,6.77,9.65,9.36,8.21,3.17,12.39,7.13,12.39,14.26,0,7.49-5.54,13.97-16.99,13.97-4.68,0-9.79-1.37-12.38-3.1l1.58-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m351.89,19.83v48.53h-6.26V19.83h6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m403.73,47.04c-.36-6.77-.79-14.91-.72-20.95h-.22c-1.66,5.69-3.67,11.74-6.12,18.43l-8.57,23.55h-4.75l-7.85-23.11c-2.3-6.84-4.25-13.11-5.62-18.87h-.14c-.14,6.05-.5,14.19-.94,21.46l-1.3,20.81h-5.98l3.38-48.53h7.99l8.28,23.47c2.02,5.98,3.67,11.3,4.9,16.35h.22c1.22-4.9,2.95-10.22,5.11-16.35l8.64-23.47h7.99l3.02,48.53h-6.12l-1.22-21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m461.62,47.04c-.36-6.77-.79-14.91-.72-20.95h-.22c-1.66,5.69-3.67,11.74-6.12,18.43l-8.57,23.55h-4.75l-7.85-23.11c-2.3-6.84-4.25-13.11-5.62-18.87h-.14c-.14,6.05-.5,14.19-.94,21.46l-1.3,20.81h-5.98l3.38-48.53h7.99l8.28,23.47c2.02,5.98,3.67,11.3,4.9,16.35h.22c1.22-4.9,2.95-10.22,5.11-16.35l8.64-23.47h7.99l3.02,48.53h-6.12l-1.22-21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m491.71,19.83v3.24h-6.26v16.35h-3.89v-16.35h-6.26v-3.24h16.42Zm21.17,19.59l-.72-11.52c-.07-1.51-.07-3.38-.14-5.47h-.22c-.5,1.73-1.08,4.03-1.66,5.83l-3.53,10.87h-4.03l-3.53-11.16c-.36-1.51-.94-3.82-1.37-5.54h-.22c0,1.8-.07,3.67-.14,5.47l-.72,11.52h-3.75l1.44-19.59h5.83l3.38,9.58c.43,1.51.79,2.95,1.3,4.97h.07c.5-1.8.94-3.46,1.37-4.9l3.38-9.65h5.62l1.51,19.59h-3.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSimmOutlines);
export default __webpack_public_path__ + "static/media/power-simm-outlines.a073b1d19e4407220ad2ccc3f763d705.svg";
export { ForwardRef as ReactComponent };